import React from 'react';

import injectReducer from 'utils/injectReducer';
import injectSaga from 'utils/injectSaga';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import reducer from './reducer';
import saga from './saga';

import _ from 'lodash';

import TrafficLights from './trafficlights'

import { makeSelectSustainabilitySelected, makeSelectCheckResponse } from './selectors'

import { updateSustainabilitySelected } from './actions'

import './styles.scss';

class PrescoringFilter extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    const id = _.uniqueId('Prescoring-');
  }

  isSelected = value => this.props.sustainabilitySelected.some(selected => selected === value);

  onClickHandler = value => {
    const { sustainabilitySelected, updateSustainabilitySelected } = this.props;

    let newSustainabilitySelected = [...sustainabilitySelected];

    if (this.isSelected(value)) {
      if (sustainabilitySelected.length > 1) {
        newSustainabilitySelected = newSustainabilitySelected.filter(sustainabilitySelectedItem => sustainabilitySelectedItem !== value)
      }
    } else {
      newSustainabilitySelected = [...newSustainabilitySelected, value]
    }

    if (sustainabilitySelected.length !== newSustainabilitySelected.length) {
      updateSustainabilitySelected(newSustainabilitySelected);
    }
  }

  render() {
    const { sustainabilitySelected } = this.props;
    let { prescoringResponse } = this.props;
    prescoringResponse = prescoringResponse.hasOwnProperty('_root') ? prescoringResponse.toJS() : prescoringResponse;

    if (!sustainabilitySelected.length) {
      return null;
    }

    let enabled = [];

    if (prescoringResponse && prescoringResponse.hasOwnProperty('chance')) {
      if (prescoringResponse.chance === 0) {
        enabled = [0];
      } else if (prescoringResponse.chance === 1 && (prescoringResponse.depositRequired === null || prescoringResponse.monthlyRateMax === null)) {
        enabled = [1];
      }
    }

    return (
      <div className="mt-2 pb-5 prescoring-tool-offers-filter">
        <div className="pull-left">
          Sostenibilità canone:
        </div>
        <div className="pull-right pt-3">
          <TrafficLights
            className="prescoring-tool-offers-filter-items-container px-1"
            onClick={!enabled.length ? value => this.onClickHandler(value) : null}
            selected={sustainabilitySelected}
            enabled={enabled}
          />
        </div>
      </div>
    );
  }
}

const withReducer = injectReducer({ key: 'prescoring', reducer });
const withSaga = injectSaga({ key: 'prescoring', saga });

const mapStateToProps = createStructuredSelector({
  sustainabilitySelected: makeSelectSustainabilitySelected(),
  prescoringResponse: makeSelectCheckResponse(),
});

export function mapDispatchToProps(dispatch) {
  return {
    updateSustainabilitySelected: sustainabilitySelected => dispatch(updateSustainabilitySelected(sustainabilitySelected)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default compose(
  withSaga,
  withReducer,
  withConnect,
)(PrescoringFilter);
